import React, { useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import moment from "moment";
import { Modal as RBModal } from "react-bootstrap";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  Select,
  DatePicker,
  Modal,
  Input,
} from "../../components";
import { axios, Constants, Globals, ENV } from "../../utils";
import PrinterIcon from "../../assets/icons/printer.png";
import FilterIcon from "../../assets/icons/icono_filtro.png";
import CloseIcon from "../../assets/icons/icono_cerrar.png";
import "./sales.css";

const ORDER_STATUS = {
  PENDING: 0,
  PROCESSED: 1,
  REJECTED: 2,
  CANCELLED: 5,
  DISPATCHED: 6,
  DELETED: 'deleted_at',
}

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      thead: [],
      trows: [],
      heading: {
        quantity: 0,
        total: 0,
      },
      header: [
        {
          value: "correlative_number",
          label: "ID",
          type: 1,
          section: "required",
          order: 0
        },
        {
          value: "created_at",
          label: "Fecha",
          type: 1,
          section: "required",
          order: 1
        },
        {
          value: "seller",
          label: "Vendedor",
          type: 1,
          section: "required",
          order: 2
        },
        {
          value: "client",
          label: "Cliente",
          type: 1,
          section: "required",
          order: 3
        },
        {
          value: "",
          label: "Categoría de Cliente",
          type: 1,
          section: "required",
          order: 4
        },
        {
          value: "",
          label: "Categoría de Producto",
          type: 1,
          section: "required",
          order: 5
        },
        {
          value: "amount",
          label: "Monto",
          type: 1,
          section: "required",
          order: 6
        },
        {
          value: "payment_method",
          label: "Método de pago",
          type: 1,
          section: "required",
          order: 8
        },
        {
          value: "status_payment",
          label: "Estatus de pago",
          type: 1,
          section: "required",
          order: 9
        },
      ],
      page: 1,
      last_page: 1,
      data: [],
      form: {
        status_payment: "",
        status: ORDER_STATUS.PROCESSED,
        search: "",
        branch_id: "",
        warehouse_id: "",
        category_id: "",
        subcategory_id: "",
        brand_id: "",
        model_id: "",
        user_id: "",
        order_id: "",
        code: true,
        name: true,
        current_stock: true,
        total: false,
        price: false,
        price_max: false,
        price_offer: false,
        cost: false,
        committed: false,
        available: false,
        since: "",
        until: "",
        payment_method_id: "",
        client_id: "",
        seller_id: "",
        web: true,
        with_categories_text: true,
        with_moderators: true,
        type_download: 'pdf',
        output: 'sales-report',
        currency: Constants.CURRENCIES.DOLARES,
        warehouse_id: '',
      },
      categories: [],
      paymentMethods: [],
      clients: [],
      client_categories: [],
      sellers: [],
      warehouses: [],
      user_id:
        this.props.user.role === 4
          ? this.props.user.enterprise_users.enterprise_id
          : this.props.user.id,
      role: this.props.user.role,
      dates: {
        minDate: "",
        maxDate: ""
      },
      statuses: [
        { value: ORDER_STATUS.PENDING, label: 'Pendiente/En proceso' },
        { value: ORDER_STATUS.PROCESSED, label: 'Procesado' },
        { value: ORDER_STATUS.REJECTED, label: 'Rechazado' },
        { value: ORDER_STATUS.CANCELLED, label: 'Anulado' },
        { value: ORDER_STATUS.DELETED, label: 'Eliminado' },
        //{value: ORDER_STATUS.DISPATCHED, label: 'Despachado'},
      ],
      selectedItem: null,
      paymentStatuses: [
        { value: Constants.PAYMENT_TYPES.PAID, label: 'Pagado' },
        { value: Constants.PAYMENT_TYPES.TO_PAY, label: 'Por Pagar' },
      ],
      toPrint: null,
      showFilters: false,
      showDatePickerDropdown: false,
      tempSince: '',
      tempUntil: '',
      sortField: null,
      sortAsc: true,
    };
  }

  abortController = new AbortController();
  searchTimeout = null;

  componentDidMount() {
    this.load();
    this.getThead();
    this.getCategories();
    this.getFilters();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    this.abortController.abort();
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.popoverRef &&
      !this.popoverRef.contains(event.target) &&
      this.dateButtonRef &&
      !this.dateButtonRef.contains(event.target)
    ) {
      this.setState({ showDatePickerDropdown: false });
    }
  };

  toggleDatePickerDropdown = () => {
    this.setState((prevState) => ({
      showDatePickerDropdown: !prevState.showDatePickerDropdown,
      tempSince: prevState.form.since ? moment(prevState.form.since).toDate() : "",
      tempUntil: prevState.form.until ? moment(prevState.form.until).toDate() : "",
    }));
  };

  applyDateRange = () => {
    this.setState(
      (prevState) => ({
        showDatePickerDropdown: false,
        form: {
          ...prevState.form,
          since: prevState.tempSince,
          until: prevState.tempUntil,
        },
      }),
      () => {
        this.getOrders(1);
      }
    );
  };

  clearDateRange = () => {
    this.setState(
      (prevState) => ({
        showDatePickerDropdown: false,
        tempSince: "",
        tempUntil: "",
        form: {
          ...prevState.form,
          since: "",
          until: "",
        },
      }),
      () => {
        this.getOrders(1);
      }
    );
  };

  handleSearchChange = (e) => {
    const val = e.target.value;
    this.setState(
      (prevState) => ({
        form: {
          ...prevState.form,
          search: val,
        },
      }),
      () => {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.getOrders(1);
        }, 500);
      }
    );
  };

  handleSort = (field) => {
    const { sortField, sortAsc, data } = this.state;
    const isAsc = sortField === field ? !sortAsc : true;
    const sortedData = [...data].sort((a, b) => {
      let valA = a[field];
      let valB = b[field];
      if (field === "total") {
        valA = parseFloat(Number(valA) || 0);
        valB = parseFloat(Number(valB) || 0);
      } else if (field === "created_at" || field === "created_es") {
        valA = moment(a.created_at || a.created_es).valueOf() || 0;
        valB = moment(b.created_at || b.created_es).valueOf() || 0;
      }
      if (valA < valB) return isAsc ? -1 : 1;
      if (valA > valB) return isAsc ? 1 : -1;
      return 0;
    });
    this.setState({ data: sortedData, sortField: field, sortAsc: isAsc });
  };

  handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= this.state.last_page && newPage !== this.state.page) {
      this.setState({ page: newPage }, () => {
        this.load();
      });
    }
  };

  renderPagination = () => {
    const { page, last_page } = this.state;
    if (!last_page || last_page <= 1) return null;

    const pages = [];
    const delta = 2;
    const left = page - delta;
    const right = page + delta;

    for (let i = 1; i <= last_page; i++) {
      if (i === 1 || i === last_page || (i >= left && i <= right)) {
        pages.push(i);
      }
    }

    const pagesWithGaps = [];
    let prev = 0;
    for (let p of pages) {
      if (prev) {
        if (p - prev === 2) {
          pagesWithGaps.push(prev + 1);
        } else if (p - prev !== 1) {
          pagesWithGaps.push("...");
        }
      }
      pagesWithGaps.push(p);
      prev = p;
    }

    return (
      <ul className="sales-pagination">
        <li>
          <button
            type="button"
            className={`sales-page-btn ${page === 1 ? "disabled" : ""}`}
            onClick={() => this.handlePageChange(1)}
            disabled={page === 1}
            title="Primera página"
          >
            «
          </button>
        </li>
        <li>
          <button
            type="button"
            className={`sales-page-btn ${page === 1 ? "disabled" : ""}`}
            onClick={() => this.handlePageChange(page - 1)}
            disabled={page === 1}
            title="Página anterior"
          >
            ‹
          </button>
        </li>
        {pagesWithGaps.map((item, idx) => {
          if (item === "...") {
            return (
              <li key={`gap-${idx}`} className="sales-page-dots">
                ...
              </li>
            );
          }
          return (
            <li key={`page-${item}`}>
              <button
                type="button"
                className={`sales-page-btn ${page === item ? "active" : ""}`}
                onClick={() => this.handlePageChange(item)}
              >
                {item}
              </button>
            </li>
          );
        })}
        <li>
          <button
            type="button"
            className={`sales-page-btn ${page === last_page ? "disabled" : ""}`}
            onClick={() => this.handlePageChange(page + 1)}
            disabled={page === last_page}
            title="Página siguiente"
          >
            ›
          </button>
        </li>
        <li>
          <button
            type="button"
            className={`sales-page-btn ${page === last_page ? "disabled" : ""}`}
            onClick={() => this.handlePageChange(last_page)}
            disabled={page === last_page}
            title="Última página"
          >
            »
          </button>
        </li>
      </ul>
    );
  };

  componentDidMount() {
    this.load();
    this.getThead();
    this.getCategories();
    this.getFilters();
  }
  componentWillUnmount() {
    this.abortController.abort();
  }

  load = () => {
    this.getOrders();
  };

  getFilters = () => {
    let { form } = this.state;

    form.user_id = this.props.user.id;

    axios
      .post("admin/reports/orders-filters", form)
      .then(res => {
        const paymentMethodsMap = res.data.payment_methods.map(({ id, name }) => ({
          value: id,
          label: name
        }));

        const clientsMap = res.data.clients.map(({ id, name }) => ({
          value: id,
          label: name
        }));

        const sellersMap = [
          ...res.data.sellers,
          ...res.data.managers,
          ...res.data.moderators,
        ].map(item => {
          const isDeleted = !!(
            item.is_deleted ||
            item.deleted ||
            item.deleted_at != null ||
            (item.status !== undefined && (item.status === 0 || item.status === '0'))
          );
          return {
            value: item.id,
            label: item.name,
            is_deleted: isDeleted,
            style: isDeleted ? { color: 'gray' } : {},
          };
        });

        const warehousesMap = res.data.warehouses.map(({ id, name }) => ({
          value: id,
          label: name
        }));

        const clientCategoriesMap = res.data.client_categories.map(({ id, name }) => ({
          value: id,
          label: name
        }));

        this.setState({
          paymentMethods: paymentMethodsMap,
          clients: clientsMap,
          sellers: sellersMap,
          warehouses: warehousesMap,
          client_categories: clientCategoriesMap,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getOrders = (resetPage = null) => {
    let { page, form } = this.state;

    if (typeof resetPage === "number") {
      page = resetPage;
    }

    form.user_id = this.props.user.id;
    form.since = !!form.since ? moment(form.since).format('YYYY-MM-DD') : '';
    form.until = !!form.until ? moment(form.until).format('YYYY-MM-DD') : '';

    Globals.setLoading();

    axios
      .post("admin/reports/orders?page=" + page, form)
      .then(res => {
        const paymentMethodsMap = res.data.payment_methods.map(({ id, name }) => ({
          value: id,
          label: name
        }));
        const clientsMap = res.data.clients.map(({ id, name }) => ({
          value: id,
          label: name
        }));
        const sellersMap = [
          ...res.data.sellers,
          ...res.data.managers,
          ...res.data.moderators,
        ].map(({ id, name }) => ({ value: id, label: name }));
        this.setState({
          last_page: res.data.orders.last_page,
          data: res.data.orders.data,
          heading: {
            quantity: res.data.orders.total,
            total: res.data.totales.total,
          }
        });
      })
      .catch(err => {
        Globals.showError();
      })
      .finally(() => Globals.quitLoading());
  };

  getCategories = () => {
    const data = {
      user_id: this.props.user.id,
    };

    axios
      .post("admin/inventory/categories", data)
      .then(res => {
        const categories = res.data?.categories?.map(({ id, name }) => ({
          value: id,
          label: name
        })) || [];

        this.setState({ categories });
      })
      .catch(err => {
        Globals.showError();
      });
  }

  change = e => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value
      }
    });
  };

  getThead = async (arr = [], arr2 = []) => {
    const { header } = this.state;

    let newHeader = arr;

    if (newHeader.length === 0) {
      newHeader = header
        .filter(Item => {
          return Item.type === 1;
        })
        .map(Item => {
          return Item.label;
        });
    }

    await this.setState(state => {
      state.thead = newHeader;
      state.trows = arr2;
    });
  };

  returnState = async () => {
    await this.setState(state => ({
      ...state,
      search: '',
      form: {
        status_payment: "",
        status: "",
        search: "",
        branch_id: "",
        warehouse_id: "",
        category_id: "",
        subcategory_id: "",
        brand_id: "",
        model_id: "",
        user_id: "",
        payment_method_id: "",
        since: "",
        until: "",
        client_id: "",
        seller_id: "",
        order_id: "",
        web: true,
        currency: Constants.CURRENCIES.DOLARES,
        warehouse_id: '',
      },
      thead: [],
      trows: [],
      toPrint: null,
      showFilters: false,
      showDatePickerDropdown: false,
      tempSince: '',
      tempUntil: '',
      sortField: null,
      sortAsc: true,
      heading: {
        quantity: 0,
        total: 0,
      },
    }));
    await this.getThead();
    await this.load();
  };

  print = (data) => {
    Globals.typeDownloadOptions(
      `Selecciona en que formato deseas que se exporte el reporte`,
      (type_download) => {
        this.setState(state => ({
          form: {
            ...state.form,
            type_download: type_download
          }
        }));
        axios
          .post("admin/reports/orders/download", this.state.form)
          .then(res => {
            if (res.data.url_storage) {
              //const url = res.data.url;
              const url = `${ENV.BasePublic}${res.data.url_storage}`;
              const win = window.open(url, "_blank");
              win.focus();
            }
            else {
              Globals.showError('Ha ocurrido un error');
            }
          })
          .catch(err => {
            Globals.showError();
          });
      }
    );
  };

  selectCurrency = (item) => {
    this.setState({ toPrint: { item, currency: this.props.currency } });
  }

  download = async (currency) => {
    try {
      const form = {
        currency,
        is_copy: true,
        order_id: this.state.toPrint.item.crypt,
        _user_id: this.props.user.id,
      };

      const res = await axios.post('admin/orders/download', form);
      if (!res.data?.url) throw new Error();

      window.open(res.data.url);
      this.setState({ toPrint: null });

    } catch (error) {
      console.log(error);
      Globals.showError('Ocurrió un error al generar el PDF. Intente nuevamente.');
    }
  }

  cancel = async (item) => {
    let done = false;

    Swal.fire({
      title: 'Ingrese el motivo de cancelación',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: (comments) => {
        if (!comments)
          return Globals.showError('Debe indicar el motivo');

        const form = {
          comments,
          order_id: item.id,
          user_id: this.props.user.id,
          _user_id: this.props.user.id,
        };

        return axios.post('admin/orders/cancel', form)
          .then(response => {
            if (response.status !== 200) throw new Error(response.statusText);
            done = true;
            return true;
          })
          .catch(() => {
            Globals.showError('Ocurrió un error al cancelar el pedido');
            return false;
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(() => {
      if (done) {
        Globals.showSuccess('Se ha cancelado el pedido correctamente');
        this.getOrders(1);
      }
    });
  }

  delete = async (item) => {
    let done = false;

    Swal.fire({
      title: 'Ingrese el motivo para eliminar el pedido',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: (comments) => {
        if (!comments)
          return Globals.showError('Debe indicar el motivo');

        const form = {
          comments,
          order_id: item.id,
          user_id: this.props.user.id,
          _user_id: this.props.user.id,
        };

        return axios.post('admin/orders/delete', form)
          .then(response => {
            if (response.status !== 200) throw new Error(response.statusText);
            done = true;
            return true;
          })
          .catch(() => {
            Globals.showError('Ocurrió un error al eliminar el pedido');
            return false;
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(() => {
      if (done) {
        Globals.showSuccess('Se ha eliminado el pedido correctamente');
        this.getOrders(1);
      }
    });
  }

  render() {
    const { form, data, heading, showFilters, showDatePickerDropdown, tempSince, tempUntil, sortField, sortAsc } = this.state;
    const hasDates = !!(form.since || form.until);
    const dateLabel = hasDates
      ? `${form.since ? moment(form.since).format('DD-MM-YYYY') : '...'} - ${form.until ? moment(form.until).format('DD-MM-YYYY') : '...'}`
      : 'Rango de fechas';
    return (
      <Menu history={this.props.history}>
        {!!this.state.toPrint && (
          <Modal
            title="Seleccionar moneda"
            onClose={() => this.setState({ toPrint: null })}
            visible
          >
            <div id="currency" className="d-flex flex-row justify-content-around mb-3">
              <button
                onClick={() => this.download(Constants.CURRENCIES.DOLARES)}
                className="currency-item bg-blue"
              >
                <span className="currency-symbol text-white">$</span>
                <span className="currency-name text-white">Dólar</span>
              </button>

              <button
                onClick={() => this.download(Constants.CURRENCIES.BOLIVARES)}
                className="currency-item bg-blue"
              >
                <span className="currency-symbol text-white">Bs</span>
                <span className="currency-name text-white">Bolívar</span>
              </button>
            </div>
          </Modal>
        )}

        {this.state.showFilters && (
          <RBModal
            tabIndex="0"
            size="lg"
            show
            onHide={() => this.setState({ showFilters: false })}
            backdropClassName="custom-modal-bd"
            contentClassName="custom-modal-content"
            visible
          >
            <RBModal.Body>
              <img
                src={CloseIcon}
                alt="Cerrar"
                className="close-btn"
                onClick={() => this.setState({ showFilters: false })}
              />

              <Filters
                form={this.state.form}
                categories={this.state.categories}
                client_categories={this.state.client_categories}
                clients={this.state.clients}
                paymentMethods={this.state.paymentMethods}
                paymentStatuses={this.state.paymentStatuses}
                sellers={this.state.sellers}
                warehouses={this.state.warehouses}
                minDate={this.state.dates.minDate}
                maxDate={this.state.dates.maxDate}
                onSearch={async (filters, close = false) => {
                  await this.setState(s => ({ ...(close ? { showFilters: false } : {}), page: 1, form: { ...s.form, ...filters } }));
                  this.load();
                }}
                onClose={() => this.setState({ showFilters: false })}
              />
            </RBModal.Body>
          </RBModal>
        )}

        <div className="sales-report-container">
          {/* Header principal */}
          <div className="sales-header">
            <div className="sales-header-title">
              <h1 className="sales-main-title">Reporte de Ventas</h1>
              <p className="sales-subtitle">
                Consulta el detalle de tus ventas y su estado de pago.
              </p>
            </div>

            <div className="sales-header-actions">
              {/* Boton Rango de Fechas */}
              {/* <button
                ref={node => (this.dateButtonRef = node)}
                type="button"
                className={`sales-btn-outline ${hasDates || showDatePickerDropdown ? "active" : ""}`}
                onClick={this.toggleDatePickerDropdown}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <span>{dateLabel}</span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button> */}

              {/* Popover selector de fechas */}
              {showDatePickerDropdown && (
                <div
                  className="sales-date-popover"
                  ref={node => (this.popoverRef = node)}
                >
                  <div className="sales-popover-title">Rango de fechas</div>
                  <div className="sales-popover-dates">
                    <div>
                      <DatePicker
                        color="white"
                        label="Desde"
                        className="filter"
                        value={tempSince}
                        onChange={val => this.setState({ tempSince: val })}
                      />
                    </div>
                    <div>
                      <DatePicker
                        color="white"
                        label="Hasta"
                        className="filter"
                        value={tempUntil}
                        onChange={val => this.setState({ tempUntil: val })}
                      />
                    </div>
                  </div>
                  <div className="sales-popover-actions">
                    <button
                      type="button"
                      className="sales-btn-sm sales-btn-secondary"
                      onClick={this.clearDateRange}
                    >
                      Limpiar
                    </button>
                    <button
                      type="button"
                      className="sales-btn-sm sales-btn-primary"
                      onClick={this.applyDateRange}
                    >
                      Aplicar
                    </button>
                  </div>
                </div>
              )}

              {/* Boton Filtros */}
              <button
                type="button"
                className="sales-btn-outline"
                onClick={() => this.setState({ showFilters: true })}
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                <span>Filtros</span>
              </button>

              {/* Boton Imprimir */}
              <button
                type="button"
                className="sales-btn-outline sales-btn-icon-only"
                title="Imprimir reporte"
                onClick={() => this.print(this.state.data)}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 6 2 18 2 18 9" />
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                  <rect x="6" y="14" width="12" height="8" />
                </svg>
              </button>
            </div>
          </div>

          {/* Tarjetas KPI */}
          <div className="sales-kpi-container">
            {/* Card 1: Pedidos realizados */}
            <div className="sales-kpi-card">
              <div className="sales-kpi-icon blue">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>
              </div>
              <div className="sales-kpi-info">
                <div className="sales-kpi-label">PEDIDOS REALIZADOS</div>
                <div className="sales-kpi-value">
                  {Number(heading.quantity || 0).toLocaleString("es-ES")}
                </div>
                <div className="sales-kpi-subtext">Total de pedidos en el periodo</div>
              </div>
            </div>

            {/* Card 2: Total pedidos */}
            <div className="sales-kpi-card">
              <div className="sales-kpi-icon green">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-3.74-1.47-3.74-3.13 0-1.5 1.14-2.73 2.67-3.11V5h2.67v1.89c1.46.34 2.66 1.34 2.81 2.97h-1.94c-.14-.85-.71-1.47-2.2-1.47-1.49 0-2.22.69-2.22 1.48 0 .66.42 1.27 2.46 1.76 2.59.61 3.95 1.48 3.95 3.32-.01 1.63-1.12 2.87-2.89 3.28z" />
                </svg>
              </div>
              <div className="sales-kpi-info">
                <div className="sales-kpi-label">TOTAL PEDIDOS</div>
                <div className="sales-kpi-value">
                  $ {parseFloat(Number(heading.total || 0)).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
                <div className="sales-kpi-subtext">Monto total de ventas</div>
              </div>
            </div>
          </div>

          {/* Tarjeta principal con buscador, tabla y paginacion */}
          <div className="sales-table-card">
            <div className="sales-table-top">
              <div className="sales-search-box">
                {/* <div className="sales-search-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </div> */}
                {/* <input
                  type="text"
                  className="sales-search-input"
                  placeholder="Buscar por ID, cliente, vendedor..."
                  value={form.search ?? ""}
                  onChange={this.handleSearchChange}
                /> */}
              </div>
            </div>

            <div className="sales-table-wrapper">
              <table className="sales-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort("created_at")}
                    >
                      Fecha{" "}
                      <span className="sort-arrows">
                        {sortField === "created_at" ? (sortAsc ? "↑" : "↓") : "↕"}
                      </span>
                    </th>
                    <th>Vendedor</th>
                    <th>Cliente</th>
                    <th>Categoría de Cliente</th>
                    <th>Categoría de Producto</th>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort("total")}
                    >
                      Monto{" "}
                      <span className="sort-arrows">
                        {sortField === "total" ? (sortAsc ? "↑" : "↓") : "↕"}
                      </span>
                    </th>
                    <th>Método de pago</th>
                    <th>Estatus de pago</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="9">
                        <div className="sales-empty-state">
                          No se encontraron registros de ventas
                        </div>
                      </td>
                    </tr>
                  ) : (
                    data.map((i, index) => {
                      const clientCat = i.client?.category?.name;
                      const isMinorista =
                        clientCat && clientCat.toLowerCase().includes("minor");
                      const isMayorista =
                        clientCat && clientCat.toLowerCase().includes("mayor");
                      const catBadgeClass = isMinorista
                        ? "sales-badge sales-badge-minorista"
                        : isMayorista
                          ? "sales-badge sales-badge-mayorista"
                          : "sales-badge sales-badge-default";

                      const isRejected =
                        i.status === Constants.ORDER_STATUS.REJECTED;
                      const isCanceled =
                        i.status === Constants.ORDER_STATUS.CANCELED ||
                        i.deleted_at !== null;
                      const isPaid =
                        !isRejected &&
                        !isCanceled &&
                        (i.status_payment === Constants.PAYMENT_TYPES.PAID ||
                          (i.status_payment_text &&
                            i.status_payment_text.toLowerCase().includes("pagad")));

                      const formattedDate = i.created_es
                        ? i.created_es
                        : i.created_at
                          ? moment(i.created_at).format("DD-MM-YYYY")
                          : "-";

                      return (
                        <tr key={i.id || index}>
                          <td>{i.correlative_number}</td>
                          <td>{formattedDate}</td>
                          <td>{i.seller?.name ?? "-"}</td>
                          <td>{i.client?.name ?? "-"}</td>
                          <td>
                            {clientCat ? (
                              <span className={catBadgeClass}>{clientCat}</span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{i.product_categories_text || "-"}</td>
                          <td className="sales-table-amount">
                            ${" "}
                            {parseFloat(Number(i.total || 0)).toLocaleString(
                              "es-ES",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                          <td>
                            {i.payment_methods_text ??
                              (i.method ? i.method?.name : "-")}
                          </td>
                          <td>
                            {isRejected ? (
                              <span className="sales-status-badge status-rejected">
                                <span className="status-dot dot-red" /> Rechazado
                              </span>
                            ) : isCanceled ? (
                              <span className="sales-status-badge status-canceled">
                                <span className="status-dot dot-gray" /> Anulado
                              </span>
                            ) : isPaid ? (
                              <span className="sales-status-badge status-paid">
                                <span className="status-dot dot-green" /> Pagado
                              </span>
                            ) : i.status_payment_text ? (
                              <span className="sales-status-badge status-pending">
                                <span className="status-dot dot-orange" />{" "}
                                {i.status_payment_text}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer con conteo de registros y paginacion */}
            <div className="sales-table-footer">
              <div className="sales-records-count">
                Mostrando {data.length} de{" "}
                {Number(heading.quantity || 0).toLocaleString("es-ES")} registros
              </div>
              {this.renderPagination()}
            </div>
          </div>
        </div>
        {/*
            <div className="col-sm-6 total-amount">
              <div className="container-total blue">
                <span className="">PEDIDOS REALIZADOS</span>
                <div>{this.state.heading.quantity}</div>
              </div>
            </div>
            <div className="col-sm-6 total-amount">
              <div className="container-total cyan">
                <span className="">TOTAL PEDIDOS</span>
                <div>{Globals.formatMiles(this.state.heading.total)} $</div>
              </div>
            </div>
          </div>

          <Table
            data={this.state.data.length}
            title="Reporte de Ventas"
            header={this.state.thead}
            right={
              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                <Button
                  title="Filtrar"
                  small="true"
                  onClick={() => this.setState({ showFilters: true })}
                >
                  <img src={FilterIcon} alt="Imprimir" />
                </Button>
                <Button
                  title="Imprimir"
                  small="true"
                  onClick={() => this.print(this.state.data)}
                >
                  <img src={PrinterIcon} alt="Imprimir" />
                </Button>
              </div>
            }
          >
            {this.state.data.map((i, index) => (
              <tr key={index}>
                <td>{i.correlative_number}</td>
                <td>{i.created_es}</td>
                <td>{i.seller?.name ?? ''}</td>
                <td>{i.client?.name ?? ''}</td>
                <td>{i.client?.category?.name ?? ''}</td>
                <td>{i.product_categories_text}</td>
                <td>{parseFloat(Number(i.total)).toFixed(2)}</td>
                <td>{i.payment_methods_text ?? (i.method ? i.method?.name : '')}</td>
                <td>
                  <span style={{ color: 'black' }}>
                    {
                      i.status !== Constants.ORDER_STATUS.REJECTED && i.status !== Constants.ORDER_STATUS.CANCELED && i.deleted_at === null ? i.status_payment_text : '-'
                    }
                  </span>
                </td>
              </tr>
            ))}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={async page => {
              await this.setState({
                page: page
              });
              this.load();
            }}
          />

        </div>
        */}
      </Menu>
    );
  }
}

const Filters = ({ form, paymentMethods, client_categories, clients, sellers, categories, paymentStatuses, warehouses, minDate, maxDate, onSearch }) => {
  const initialFilters = {
    order_id: '',
    payment_method_id: '',
    category_id: '',
    client_id: '',
    client_category_id: '',
    seller_id: '',
    since: '',
    until: '',
    status: '',
    status_payment: '',
    warehouse_id: '',
  };

  const searchTimeout = React.useRef(null);
  React.useEffect(() => {
    return () => {
      if (searchTimeout.current) clearTimeout(searchTimeout.current);
    };
  }, []);

  const [_form, setForm] = useState({
    order_id: form.order_id ?? '',
    payment_method_id: form.payment_method_id ?? '',
    category_id: form.category_id ?? '',
    client_id: form.client_id ?? '',
    client_category_id: form.client_category_id ?? '',
    seller_id: form.seller_id ?? '',
    since: !!form.since ? moment(form.since).toDate() : '',
    until: !!form.until ? moment(form.until).toDate() : '',
    status: form.status ?? '',
    status_payment: form.status_payment ?? '',
    warehouse_id: form.warehouse_id ?? '',
  });

  const autoFilter = (newForm, isText = false) => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    if (isText) {
      searchTimeout.current = setTimeout(() => {
        onSearch(newForm, false);
      }, 700);
    } else {
      onSearch(newForm, false);
    }
  };

  const onChange = (value, target, isText = false) => {
    setForm(s => {
      const next = { ...s, [target]: value };
      autoFilter(next, isText);
      return next;
    });
  }

  const reset = () => {
    setForm(initialFilters);
    onSearch(initialFilters, false);
  }

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0 1rem', padding: '1rem 2rem 0' }}>
        <div>
          <DatePicker
            color="white"
            label="Desde"
            className="filter"
            value={_form.since}
            minDate={minDate}
            onChange={v => onChange(v, 'since', false)}
          />
        </div>
        <div>
          <DatePicker
            color="white"
            label="Hasta"
            className="filter"
            value={_form.until}
            maxDate={maxDate}
            onChange={v => onChange(v, 'until', false)}
          />
        </div>

        <div>
          <Input
            color=" "
            label="ID"
            className="filter"
            value={_form.order_id}
            onChange={v => onChange(v.target.value, 'order_id', true)}
          />
        </div>

        <div>
          <Select
            color="white"
            label="Método de pago"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'payment_method_id')}
            value={_form.payment_method_id}
            options={paymentMethods}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Cliente"
            className="filter"
            truncateLabel={27}
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'client_id')}
            value={_form.client_id}
            options={clients}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Categoría de Cliente"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'client_category_id')}
            value={_form.client_category_id}
            options={client_categories}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Vendedor"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'seller_id')}
            value={_form.seller_id}
            options={sellers}
          />
        </div>

        <div>
          <Select
            color="white"
            label="Categoría de Producto"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'category_id')}
            value={_form.category_id}
            options={categories}
          />
        </div>
        {/* <div>
          <Select
            color="white"
            label="Estatus"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'status')}
            value={_form.status}
            options={statuses}
          />
        </div> */}
        <div>
          <Select
            color="white"
            label="Estatus de pago"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'status_payment')}
            value={_form.status_payment}
            options={paymentStatuses}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Almacén"
            className="filter"
            style={{ textTransform: "capitalize" }}
            onChange={e => onChange(e.target.value, 'warehouse_id')}
            value={_form.warehouse_id}
            options={warehouses}
          />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className="btn-align-bottom btn-filter"
          style={{ minWidth: 110, maxWidth: 110, marginRight: 0 }}
          color=" "
          onClick={reset}
        >
          <span>Limpiar</span>
        </Button>
      </div>
    </>
  )
}

export default connect(state => {
  return {
    user: state.user,
    currency: state.currency,
  };
})(Report);
